import React, { Component } from 'react';
import Modal from 'react-modal';
import copyToClipboard from 'copy-to-clipboard';
import NotificationSystem from 'react-notification-system';
import {gtmSend} from '../../../../helpers';
import cx from '../../../../styles';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

const customStyles = {
        content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            marginRight           : '-50%',
            transform             : 'translate(-50%, -50%)'
        }
    };

class ShareModal extends Component {

    constructor(props) {
        super(props);
        this.state = {isOpen: false, isShowNotification: true};
    }

    addNotificationToModal = (message, level) => {
        if(this.state.isShowNotification) {
            this.setState({isShowNotification: false})
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(()=>{
                this.setState({isShowNotification: true})
            }, 3000)
        }
    }

    openModal = () => {
        this.setState({isOpen: true});
    }

    closeModal = () => {
        this.setState({isOpen: false});
    }

    onModalOpen = () => {
        window.scrollTo(0, this.props.position);
        this.setState({isOpen: true});
    }

    onModalClose = () => {
        this.setState({isOpen: false});
        this.props.onModalClose();
    }

    onCopy = () => {
        const appender = this.props.shareType == 'reply' ? '&' : '?';
        const copyContent = this.props.siteUrl + this.props.slug + appender +'utm_source=community.theasianparent.com&utm_medium=copy&utm_campaign=post-share';
        copyToClipboard(copyContent);
    }

    shareAction = (type) => {
        let link;
        const domain = this.props.siteUrl;        
        const shareType = this.props.shareType;
        const t = this.props.t;
        const cardCategory = shareType == 'question' ? 'card-main' : `card-${shareType}`;
        const appender = this.props.shareType == 'reply' ? '&' : '?';
        gtmSend(`click ${shareType} share`, cardCategory, `share:${type}`, `url:${domain+this.props.slug}, id: ${this.props.id}`);
        gtmSend(`cw_share`, `${this.props.cardName}`, `Share`, `${type}`, 0, {card_type: `${this.props.cardName}`, topic_id: `${this.props.topic? `${this.props.topic.id}`:'--'}`, topic_name: `${this.props.topic? `${this.props.topic.name}`:'--'}`, [this.props.cardName === 'Reply Card'?'reply_id': 'card_id']: `${this.props.id}`});
        switch(type) {
            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${domain + this.props.slug + appender + 'utm_source=community.theasianparent.com&utm_medium=facebook&utm_campaign=post-share'}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            break;
            case 'email':
                link = `mailto:?&subject=Invitation from ${this.props.username}&body=Hi,
                    You have received an invitation to join the AsianParent Community. Join your friend by clicking the link below -
                    ${domain + this.props.slug + appender}utm_source=community.theasianparent.com&utm_medium=email&utm_campaign=post-share`
                window.open(link, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            break;
            case 'copy':
                this.onCopy();
                this.addNotificationToModal(t('community_action_copy'), 'success');
            break;
            default:
        }
    }

    render() {
        return (
            <React.Fragment>

                <NotificationSystem ref={n => this._notificationSystem = n} />

                <Modal isOpen={this.props.isModalOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass share-modal-overlay"
                    style={customStyles} >

                    <div className={cx("share-modal")}>                        

                        <div className={cx("bg-img", "only-desktop")} style={{backgroundImage: "url(https://parenttown.com/assets/images/invite_icon.jpg)"}}></div>

                        <section>
                            <p></p>

                            <div>
                                <button className={cx("fb", "pointer-click")} onClick={()=>this.shareAction('facebook')}>Share via Facebook</button>
                            </div>
                            <div>
                                <button className={cx("email", "pointer-click")} onClick={()=>this.shareAction('email')}>Share via Email</button>
                            </div>
                            <div>
                                <button className={cx("copy-link", "pointer-click")} onClick={()=>this.shareAction('copy')}>Copy the link</button>
                            </div>
                        </section>
                    </div>
                </Modal>

            </React.Fragment>
        );
    }
}

export default ShareModal;
